import { setupNetwork } from "./network";

export function runInitialJobs() {
  setupNetwork();
}



// WEBPACK FOOTER //
// ./src/components/ui-ant/misc/initial.js